/**
 * KURUM HESABI — İSTEMCİ MUTASYONLARININ İNVALİDASYONU (K4 · Story H8, H10).
 *
 * `invalidation.ts` dosya tavanına dayandığı için aile burada durur ve oraya
 * yayılır; anahtar uzayı ve harita TEKTİR (`CACHE_KEYS`, `INVALIDATION_MAP`).
 * Anahtarlar dışarıdan verilir: bu dosya `invalidation.ts`i içe aktarmaz
 * (döngüsel bağımlılık olmaz).
 *
 * - Bana gelmiş davetin kabulü üyelik doğurur: kurum listesi ve yönetilen
 *   etkinlikler değişir.
 * - Davetli kayıt (kod + şifre) ve davetli Google/Apple kaydı oturumu KURUM
 *   hesabıyla açar ve üyeliği aynı işlemde yazar: bant ve ana sayfa kurum
 *   listesini ilk kez okur.
 */
export function orgAccountInvalidation(keys) {
    return {
        'orgAccount/acceptMyInvitation': [keys.organizationList, keys.myEvents],
        'orgAccount/invitationConfirm': [keys.organizationList],
        'orgAccount/invitationOauth': [keys.organizationList],
    };
}
//# sourceMappingURL=invalidation-org-account.js.map